<template>
  <div class="report-index">
    <div style="height: 70px; padding: 0 30px" class="uc ub-ac">
      <div>
        <img :src="logoimg" style="width: 15rem" />
      </div>
      <div class="uc ub-ac title-css">“清廉天能”举报平台</div>
    </div>
    <div class="banner">
      <div style="height: 20vh">
        <el-carousel style="height: 100%" height="100%" :autoplay="false">
          <el-carousel-item
            v-for="item in 1"
            :key="item"
            style="height: 100%; width: 100%"
          >
            <div style="position: relative; width: 100%; height: 100%; top: 0">
              <el-image
                style="width: 100%; height: 100%"
                :src="banner"
                fit="cover"
              ></el-image>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div style="width: 100%; background: #fafafa">
      <div class="model-css" style="">
        <div class="title-h2">“清廉天能”举报平台</div>

        <div class="-row">
          <el-row :gutter="6" class="header-tip-css" style="">
            <el-col :xs="12" :sm="6">
              <div class="-col uc ub-ac">
                <div class="col-size col-bg-1">
                  <div>
                    <h3>举报保密</h3>
                    <p>
                      我们承诺对举报人的相关信息、内容、证据等严格保密，举报事项列入机密管理。
                      <br /><br />
                      严禁任何人采取任何方式对举报人进行打击报复，若存有上述行为，我们将追究相关人员的责任。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="12" :sm="6">
              <div class="-col uc ub-ac">
                <div class="col-size col-bg-2">
                  <div>
                    <h3>鼓励实名</h3>
                    <p>
                      您可选择实名或匿名举报，为便于及时与您跟进反馈及后续兑现奖励，我们鼓励实名举报。
                      <br /><br />
                      举报时尽可能告知举报事实，提供相关证据，并对举报内容真实性负责，不得利用举报渠道进行报复、诬告、诽谤。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="12" :sm="6">
              <div class="-col uc ub-ac">
                <div class="col-size col-bg-3">
                  <div>
                    <h3>举报奖励</h3>
                    <p>
                      举报事项经查证属实，集团将按照举报事项的事实、情节、挽回的损失等情况对举报人进行奖励。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="12" :sm="6">
              <div class="-col uc ub-ac">
                <div class="col-size col-bg-4">
                  <div>
                    <h3>受理范围</h3>
                    <p>
                      受理损害集团利益、失职失责等各类违规违纪行为，包括采购、招投标、营销、财务、工程、人力等领域的内部商业贿赂、职务侵占、泄露公司秘密等违法犯罪行为。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div
          style="width: 100%; margin: 20px auto"
          :class="[device ? 'uc' : 'ub ub-ac']"
        >
          <div :class="['uc', 'ub-ac', device ? 'ub-pc' : '', '-report-type']">
            <div class="iconfont icon-youxiang -icon"></div>
            <div class="-icon-title">举报邮箱</div>
            <div class="-icon-text">
              <a class="-icon-text" href="mailto:tiannengjubao@163.com"
                >tiannengjubao@163.com</a
              >
            </div>
          </div>
          <div :class="['uc', 'ub-ac', device ? 'ub-pc' : '', '-report-type']">
            <div class="iconfont icon-dianhua1 -icon"></div>
            <div class="-icon-title">举报电话</div>
            <div class="-icon-text">
              <a class="-icon-text" href="tel:13857823563">13857823563</a>
              /
              <a class="-icon-text" href="tel:13588424906">13588424906</a>
            </div>
          </div>
          <div :class="['uc', 'ub-ac', device ? 'ub-pc' : '', '-report-type']">
            <div class="iconfont icon-qqhover -icon"></div>
            <div class="-icon-title">举报QQ</div>
            <div class="-icon-text">2179414802</div>
          </div>
        </div>
      </div>
      <div
        class="ub ub-ac ub-pc"
        style="
          width: 50%;
          margin: auto;
          padding-top: 1.5rem;
          padding-bottom: 2rem;
        "
      >
        <el-button
          @click="jumpReport"
          type="primary"
          class="-button"
          :style="{
            width: device ? '50%' : '100%',
            'border-radius': '30px',
            background: '#006FC2',
            'font-size': '2rem',
          }"
        >
          在线举报
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
      <div style="background: #d0cfcf; height: 5rem" class="uc ub-ac ub-pc">
        <div
          style="
            font-family: '微软雅黑', 宋体, Arial, sans-serif;
            font-size: 12px;
            line-height: 28px;
            color: #ffffff;
          "
          align="center"
        >
          Copyright © 天能控股集团 All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logoimg from "@/assets/image/logo2.png";
import bannerpc from "@/assets/image/banner-pc.jpg";
import bannerwx from "@/assets/image/banner-wx.jpg";

// import h031 from '@/assets/image/h03-1.png'
// import h032 from '@/assets/image/h03-2.png'
// import h041 from '@/assets/image/h04-1.png'
// import h042 from '@/assets/image/h04-2.png'
// import h051 from '@/assets/image/h05-1.png'
// import h052 from '@/assets/image/h05-2.png'
// import h061 from '@/assets/image/h06-1.png'
// import h062 from '@/assets/image/h06-2.png'

export default {
  name: "report-index",
  data() {
    return {
      banner: bannerpc,
      logoimg: logoimg,
      device: true,
      status: false,
    };
  },
  created() {
    if (window.screen.width < window.screen.height) {
      this.device = false;
      this.banner = bannerwx;
    } else {
      this.device = true;
      this.banner = bannerpc;
    }
  },
  methods: {
    jumpReport() {
      this.$router.push("/report");
    },
  },
};
</script>
<style lang="scss" scoped>
.report-index {
  background: #fff;

  .title-css {
    padding: 0 20px;
    font-size: 1.8rem;
    line-height: 100%;
    letter-spacing: 3px;
    font-weight: 700;
    color: #006fc2;
  }

  .title-h2:before {
    content: "";
    width: 9rem;
    border-bottom: 0.4rem solid #002d72;
    display: block;
    position: absolute;
    top: 0;
  }

  .title-h2 {
    font-size: 3.6rem;
    color: #006fc2;
    // color: #c1a367;
    font-weight: 400;
    padding-top: 1.5rem;
    position: relative;
  }
  .model-css {
    padding-top: 5rem;
  }
  h3 {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 200;
    color: #002d72;
  }
  p {
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 1px;
  }

  /*定义竖屏 css*/
  @media screen and (orientation: portrait) {
    .model-css {
      width: 95%;
      margin: auto;
      .title-h2 {
        width: 90%;
        margin: auto;
      }
      .-row {
        margin: 20px 0;
        padding: 5px 0;
        border-top: 5px solid #17407f;
        border-bottom: 5px solid #17407f;
      }
      .-col {
        margin-bottom: 10px;
        .col-bg-1 {
          background: url("../assets/image/h03-2.jpg") no-repeat;
        }
        .col-bg-2 {
          background: url("../assets/image/h04-2.jpg") no-repeat;
        }
        .col-bg-3 {
          background: url("../assets/image/h05-2.jpg") no-repeat;
        }
        .col-bg-4 {
          background: url("../assets/image/h06-2.jpg") no-repeat;
        }
        .col-size {
          width: 100%;
          margin: auto;
          height: 46rem;
          margin: 0;
          background-size: cover;
          background-position: center center;
          border: 1px solid rgba(23, 70, 131, 0.3);
          h3 {
            text-align: center;
            font-size: 2.2rem;
            font-weight: 600;
          }
          p {
            line-height: 3rem;
            color: rgba(23, 70, 131, 1);
          }
          div {
            width: 80%;
            margin: auto;
          }
        }
      }
      .-report-type {
        width: 90%;
        padding-bottom: 1.5rem;

        .-icon {
          font-size: 2.5rem;
          padding: 0 10px;
          color: #006fc2;
        }
        .-icon-title {
          font-size: 1.6rem;
          // color: #c1a367;
          color: #006fc2;
          font-weight: 700;
          padding-right: 10px;
        }
        .-icon-text {
          font-size: 1.5rem;
          color: rgba(23, 70, 131, 0.8);
        }
      }
    }
  }

  /*定义横屏 css*/
  @media screen and (orientation: landscape) {
    .model-css {
      width: 55%;
      min-width: 940px;
      margin: auto;
      .-row {
        margin: 20px 0;
        padding: 5px 0;
        border-top: 5px solid #17407f;
        border-bottom: 5px solid #17407f;
      }
      .-col {
        // .col-bg-1{
        //   background: linear-gradient(rgba(245,246,247,0.8), rgba(255,255,255, 0.6)), url('../assets/image/h03-1.jpg') no-repeat
        // }
        // .col-bg-2{
        //   background: linear-gradient(rgba(245,246,247,0.8), rgba(255,255,255, 0.6)),url('../assets/image/h04-1.jpg') no-repeat;
        // }
        // .col-bg-3{
        //   background: linear-gradient(rgba(245,246,247,0.8), rgba(255,255,255, 0.6)),url('../assets/image/h05-1.jpg') no-repeat;
        // }
        // .col-bg-4{
        //   background: linear-gradient(rgba(245,246,247,0.8), rgba(255,255,255, 0.6)),url('../assets/image/h06-1.jpg') no-repeat;
        // }
        .col-bg-1 {
          background: url("../assets/image/h03-1.jpg") no-repeat;
        }
        .col-bg-2 {
          background: url("../assets/image/h04-1.jpg") no-repeat;
        }
        .col-bg-3 {
          background: url("../assets/image/h05-1.jpg") no-repeat;
        }
        .col-bg-4 {
          background: url("../assets/image/h06-1.jpg") no-repeat;
        }
        .col-size {
          width: 100%;
          margin: auto;
          height: 410px;
          margin: 0;
          background-size: cover;
          background-position: center center;

          h3 {
            text-align: center;
            font-size: 2.3rem;
          }
          p {
            line-height: 2.3rem;
            color: rgba(23, 70, 131, 0.8);
          }
          div {
            width: 85%;
            margin: auto;
          }
        }
      }
      .-icon {
        font-size: 2.5rem;
        padding: 0 10px;
        color: #006fc2;
      }
      .-icon-title {
        font-size: 1.3rem;
        // color: #c1a367;
        color: #006fc2;
        font-weight: 200;
        padding-right: 10px;
      }
      .-icon-text {
        font-size: 1.2rem;
        color: rgba(23, 70, 131, 0.8);
      }
    }
    .-report-type {
      width: 33.3333%;
    }
  }

  .ub {
    display: flex;
    flex-direction: column;
  }
  .ub-f1 {
    flex: 1;
  }
  .uc {
    display: flex;
    flex-direction: row;
  }
  .ub-pc {
    justify-content: center;
  }

  .ub-end {
    justify-content: flex-end;
  }

  .uc-end {
    align-items: flex-end;
  }
  .ub-ac {
    /* align-content: center; */
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue